import { render } from "./GroupBuyDetail.vue?vue&type=template&id=7b7e70a0&scoped=true"
import script from "./GroupBuyDetail.vue?vue&type=script&lang=js"
export * from "./GroupBuyDetail.vue?vue&type=script&lang=js"

import "./GroupBuyDetail.vue?vue&type=style&index=0&id=7b7e70a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7e70a0"]])

export default __exports__